import type { ReviewOfferProduct } from "../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import {
  BACKUP_ID,
  POWER_MANAGEMENT_PRODUCT_ID,
  PRODUCT_DISPLAY_ORDER,
} from "constants/bundleAndProductIds";

const BATTERY_IDS = new Set<string>(PRODUCT_DISPLAY_ORDER.BATTERIES);
const EV_CHARGER_IDS = new Set<string>(PRODUCT_DISPLAY_ORDER.EV_CHARGER);

const getProductSortIndex = (productId: string): number => {
  if (BATTERY_IDS.has(productId)) return 0;
  if (productId === PRODUCT_DISPLAY_ORDER.SOLAR) return 1;
  if (EV_CHARGER_IDS.has(productId)) return 2;
  return 3;
};

/** Simplified offer review: Solar → battery → EV charger → SPAN */
const getSimplifiedOfferReviewProductSortIndex = (
  productId: string
): number => {
  if (productId === PRODUCT_DISPLAY_ORDER.SOLAR) return 0;
  if (BATTERY_IDS.has(productId)) return 1;
  if (EV_CHARGER_IDS.has(productId)) return 2;
  if (productId === POWER_MANAGEMENT_PRODUCT_ID) return 3;
  return 4;
};

const sortProductsByDisplayOrder = (
  products: ReviewOfferProduct[]
): ReviewOfferProduct[] =>
  [...products].sort(
    (a, b) =>
      getProductSortIndex(a.productId) - getProductSortIndex(b.productId)
  );

const sortSimplifiedOfferReviewProducts = (
  products: ReviewOfferProduct[]
): ReviewOfferProduct[] =>
  [...products].sort(
    (a, b) =>
      getSimplifiedOfferReviewProductSortIndex(a.productId) -
      getSimplifiedOfferReviewProductSortIndex(b.productId)
  );

const getReviewOfferProductsIdentityKey = (
  products: ReviewOfferProduct[]
): string =>
  products
    .map((product) => `${product.productId}:${product.count}`)
    .sort()
    .join("|");

/** Default carousel slide: Backup battery when present, otherwise first battery product. */
const getSimplifiedOfferReviewCarouselDefaultIndex = (
  sortedProducts: ReviewOfferProduct[]
): number => {
  if (sortedProducts.length === 0) {
    return 0;
  }

  const backupIndex = sortedProducts.findIndex(
    (product) => product.productId === BACKUP_ID
  );
  if (backupIndex >= 0) {
    return backupIndex;
  }

  const firstBatteryIndex = sortedProducts.findIndex((product) =>
    BATTERY_IDS.has(product.productId)
  );
  if (firstBatteryIndex >= 0) {
    return firstBatteryIndex;
  }

  return 0;
};

export {
  getReviewOfferProductsIdentityKey,
  getSimplifiedOfferReviewCarouselDefaultIndex,
  sortProductsByDisplayOrder,
  sortSimplifiedOfferReviewProducts,
};
